/** `title` makes the icon announce itself; without one it is decorative. */
type Props = { className?: string; title?: string }

/** The design's 12px red warning triangle (Figma `Icon / TriangleAlert`). Stroke follows `color`. */
export const TriangleAlertSmallIcon = ({ className, title }: Props) => (
	<svg
		className={className}
		width="12"
		height="12"
		viewBox="0 0 12 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		role={title ? "img" : undefined}
		aria-label={title}
		aria-hidden={title ? undefined : true}
	>
		<path
			d="M6 4.5V6.5M6 8.5H6.005M10.865 8.99999L6.86496 1.99999C6.77775 1.84609 6.65127 1.71808 6.49843 1.62902C6.34559 1.53997 6.17186 1.49304 5.99496 1.49304C5.81807 1.49304 5.64434 1.53997 5.4915 1.62902C5.33866 1.71808 5.21218 1.84609 5.12496 1.99999L1.12496 8.99999C1.03681 9.15267 0.990579 9.32594 0.990969 9.50224C0.99136 9.67855 1.03835 9.85162 1.12719 10.0039C1.21602 10.1562 1.34354 10.2823 1.49681 10.3694C1.65009 10.4565 1.82367 10.5016 1.99996 10.5H9.99996C10.1754 10.4998 10.3477 10.4535 10.4996 10.3656C10.6515 10.2778 10.7776 10.1515 10.8652 9.99955C10.9529 9.84756 10.999 9.67518 10.9989 9.49973C10.9989 9.32428 10.9527 9.15193 10.865 8.99999Z"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
